import { useEffect, useRef } from 'react'
import gsap from 'gsap'
import styled from 'styled-components'
import { ContainerText } from '@components/styled'
import { TextBlock } from '@components/content'
import { windowLoadWithTimetout } from '@utils/timeout'

const Container = styled(ContainerText)`
  opacity: 0;
  transform: scale(0.8);
  transform-origin: top center;

  > *:last-child {
    margin-bottom: 0;
  }
`

const TextLayout: React.FC = ({ children }) => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    windowLoadWithTimetout(() => {
      gsap
        .timeline()
        .to(containerRef.current as gsap.TweenTarget, {
          scale: 1,
          ease: 'power4.out',
          duration: 0.4,
        })
        .to(
          containerRef.current as gsap.TweenTarget,
          {
            opacity: 1,
            ease: 'power3.out',
            duration: 0.2,
          },
          '<',
        )
    })
  }, [])

  return (
    <Container ref={containerRef} className="mb-80 mb-md-200">
      <TextBlock>{children}</TextBlock>
    </Container>
  )
}

export default TextLayout
